import { useSuspenseQuery } from '@tanstack/react-query';
import { bookingsGet } from '@/api/bookings/bookings/bookingsGet';

export const useBookings = () => useSuspenseQuery({
    queryKey: ['bookings'],
    queryFn: () => bookingsGet().then(r => r.payload)
});
